import React from "react";
import styled from "styled-components";
import IUMRSNavBar from "./IUMRSNavbar";
import { ICAMNavroute } from '../../../utils/ICAMnavroute.js'
import IUMRSFooter from "./IUMRSFooter";
import { CIcon } from '@coreui/icons-react';
import { cilCheckAlt } from "@coreui/icons";
import { useDesktopSiteDetection } from "../../../hooks/mobile_desktop_mode.jsx";
import NotificationDropdown from "../../../hooks/notificationsDropdown.jsx";


const SponsorPackage = () => {
    const isDesktopSiteOnMobile = useDesktopSiteDetection();

    const packageData = [
        {
            title: "Platinum Package",
            price: "$50,000.00",
            benefits: [
                "Full advertising space in the book of abstracts",
                "Mount exhibition stand during the conference" ,
                "Display your logo in all conference literature, including conference venue and also the conference webpage, with a link to your website",
                "Your support will also be acknowledged during the welcome ceremony and at the conference dinner in addition to three (3) company representatives registering and attending the conference for free",
                "20m x 20m booth."
            ]
        },
        {
            title: "Diamond Package",
            price: "$30,000.00",
            benefits: [
                "Full advertising space in the book of abstracts",
                "Mount exhibition stand during the conference",
                "Display your logo in all conference literature, including conference venue and also the conference webpage, with a link to your website",
                "Your support will also be acknowledged during the welcome ceremony and at the conference dinner in addition to two (2) company representative registering and attending the conference for free",
                "20m x 20m booth."
            ]
        },
        {
            title: "Gold Package",
            price: "$20,000.00",
            benefits: [
                "Half advertising space in the book of abstracts",
                "Mount exhibition stand during the conference",
                "Display your logo in all conference literature, including conference venue and also the conference webpage, with a link to your website",
                "Your support will also be acknowledged during the welcome ceremony and at the conference dinner in addition to two (2) company representative registering and attending the conference for free",
                "9m x 9m booth."
            ]
        },
        {
            title: "Silver Package",
            price: "$10,000.00",
            benefits: [
                "Mount exhibition stand during the conference",
                "Display your logo in all conference literature, including conference venue and also the conference webpage, with a link to your website",
                "Your support will also be acknowledged during the welcome ceremony and at the conference dinner in addition to one (1) company representative registering and attending the conference for free",
                "9m x 9m booth."
            ]
        },
        {
            title: "Bronze Package",
            price: "$5,000.00",
            benefits: [
                "Mount exhibition stand during the conference",
                "Display your logo in all conference literature, including conference venue and also the conference webpage, with a link to your website",
                "Your support will also be acknowledged during the welcome ceremony and at the conference dinner"
            ]
        }
    ];

    return (
        <Wrapper>
        <IUMRSNavBar navroute={ICAMNavroute}/>
        <NotificationDropdown />
            <Container className={isDesktopSiteOnMobile ? 'desktop-site-mode' : ''}>
                <div className="header">
                    <h2>SPONSORSHIPS</h2>
                </div> 
                <div className="summary-section">
                    <div className="intro-text">
                        <span><i>Important notice</i></span>  
                    </div>

                    <div className="main-text">
                        <p> The upcoming conference, with an expected on-site participation of 600-800 delegates 
                            (Africa, Europe, Asia, North America, South America, and Australia), comprises, technical symposia, 
                            plenary and theme lectures, special activities, exhibition as well as keynote, invited, oral and poster presentations. 
                            All participants will have the opportunity to share research, foster collaborations, and address unique 
                            challenges and opportunities for materials innovations. The variety of activities will provide opportunities to 
                            engage with the scientific community, from experts to young researchers and students of all ages, as well as government 
                            representatives and policy-makers from most countries worldwide. </p>

                        <p>We therefore have the pleasure to invite you to participate in this meeting and to be a sponsor and/or exhibitor, and/or 
                            organize a workshop during the Pre-conference workshop sessions (7– 8 December, 2025).
                        <br /> <br />Below are the available sponsorship packages. Organizations interested solely in exhibiting their products or 
                        services during the conference may consider the Bronze package. </p>
                    </div>
                </div>

                <Packages>
            <Cards>
                {packageData.map((pack, index) => (
                    <div className="offer" key={index}>
                        <div className="package-section">
                            <div className="package-title">
                                <h2>{pack.title}</h2>
                                <h3>{pack.price}</h3>
                            </div>
                        </div>
                        <ul>
                            {pack.benefits.map((benefit, idx) => (
                                <li key={idx}>
                                    <span className="check-icon">
                                        <CIcon 
                                            icon={cilCheckAlt} 
                                            style={{ width: "24px", height: "20px", color: "green" }} 
                                        />
                                    </span>
                                    <span className="benefit-text">{benefit}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </Cards>
        </Packages>

                
            </Container>
            <IUMRSFooter />

        </Wrapper>
    )
}

const Wrapper = styled.div`
`

const Packages = styled.div`
    display: flex;
    justify-content: center;
    margin: 7rem auto;
    font-family: 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
`;

const Cards = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 80%;
    gap: 20px;

    .offer {
        position: relative;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        width: 20rem;
        height: auto;
        min-height: 35rem;
        border: 1.5px solid rgb(231, 218, 218);
        border-radius: 10px;
        box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
        overflow: hidden;
    }

    .package-section {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 8rem;
        padding: 1rem 0;
    }

    .package-title {
        background-color: #082D4A;
        color: white;
        width: 85%;
        border-radius: 10px;
        padding: 1rem;
        text-align: center;

        h2 {
        margin-bottom: 0.5rem;
        font-size: 1.5rem;
        font-weight: 600;
        font-family: 'Montserrat', 'Segoe UI', sans-serif;
        letter-spacing: 0.5px;
    }


        h3 {
        margin-top: 0;
        font-size: 1.5rem;
        font-weight: 700;
        color: #e9f3ff;
        letter-spacing: 0.5px;
        font-family: 'Montserrat', 'Segoe UI', sans-serif;
        }
    }

    ul {
        list-style-type: none;
        padding: 1rem;
        display: flex;
        flex-direction: column;
        gap: 15px;
        flex-grow: 1;
    }

    li {
        display: flex;
        align-items: flex-start;
        font-family: 'Open Sans', 'Segoe UI', sans-serif;
    }

    .check-icon {
        flex-shrink: 0;
        margin-right: 10px;
        margin-top: 3px;
    }

    .benefit-text {
        flex-grow: 1;
    }
`;

const Container = styled.div`
    font-family: "Noto Serif", serif;
    font-weight: 300;
    p, li{color: rgb(97, 96, 96);}

    .header{
        width: 100%;
        height: 10rem;
        background-color: #082D4A;
        margin: 0;
        text-align: center;
        
    h2{
            margin: 0;
            color: white;
            font-family: "PT Serif", serif;
            font-style: normal;
            font-weight: 600;
            letter-spacing: .005em;
            font-size: 1.5rem;
            line-height: 10rem;
            
        }
    }

    .summary-section{
        margin: 2em 2em 1em 2em;

        p{
            line-height: 1.8em;
            font-size: 1.1em;

            .highlight{color: #a12016;}
        }

        .main-text{text-align: justify}
        
    }
    .intro-text {
        width: 100%;
        display: flex;
        justify-content: center;
        text-align: center;
        margin-bottom: 1.5rem;

        span{
            color:  #082D4A;
            font-weight: 600;
            font-size: 1.7rem;
        }
        
        
        p {
            max-width: 90%;
            
            
        }
    }

    .heading {
        color: #082D4A;
        font-size: 1.5rem;
        font-weight: 500;
    }

    @media only screen and (min-width: 800px) {
        .header{
            h2{font-size: 2rem;}
        }
        .summary-section{
            margin: 0em 3em 1em 3em;

            .intro-text {margin-top: 3rem;}
        }
    }

    @media only screen and (min-width: 1000px) {
        .title{
            h2{
                font-size: 2.9em;
            }
        }
        .summary-section{
            width: 56em;
            margin: 0 auto;
        }
    }

    &.desktop-site-mode {
        
        .summary-section {
            margin: 3em;
            
            p {
                font-size: 0.65em;
                line-height: 1.5em;
            }
        }
        
        .intro-text span {
            font-size: 2em;
        }
        
        .heading {
            font-size: 0.9em;
        }
    }
`


export default SponsorPackage